// services/contexts/user-context.js
import { createContext, useContext } from 'react';

export const UserContext = createContext({
    user: null,
    isLoading: true,
});

export const useUser = () => useContext(UserContext);
